import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "incidentFilled"
const IncidentFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M10.909 2.657C11.501 2.03 12.499 2.03 13.092 2.657L14.537 4.191 16.61 3.8C17.457 3.64 18.265 4.227 18.375 5.083L18.643 7.173 20.548 8.075C21.328 8.445 21.638 9.394 21.223 10.151L20.212 12 21.223 13.848C21.637 14.606 21.329 15.556 20.548 15.925L18.643 16.826 18.375 18.917C18.265 19.773 17.457 20.36 16.609 20.2L14.537 19.81 13.092 21.342C12.5 21.97 11.502 21.97 10.909 21.343L9.463 19.809 7.392 20.2C6.544 20.36 5.736 19.774 5.626 18.918L5.357 16.827 3.452 15.924C2.672 15.556 2.363 14.605 2.778 13.85L3.789 12 2.778 10.15C2.364 9.395 2.672 8.445 3.452 8.076L5.357 7.173 5.627 5.083C5.735 4.227 6.543 3.64 7.391 3.8L9.463 4.19zM10.875 14.625V16.875H13.125V14.625zM10.875 13.125H13.125V7.125H10.875z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default IncidentFilledIcon
